import {
	API_PATCH_MULTIPLE_TUBE,
	API_PATCH_TUBE,
	API_DELETE_TUBE,
	API_POST_TUBE,
	API_POST_REUSABLE_TUBE,
	API_GET_MISSING_VOLUME_TUBE,
} from 'actions/tube';
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_PATCH_TUBE]: {
		default: (tube) => `/tubes/${tube.id}`,
		v2: (tube) => `/tubes/${tube.id}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_MULTIPLE_TUBE]: {
		default: "/tubes/bulk",
		v2: "/tubes/bulk",
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_TUBE]: {
		default: "/tubes",
		v2: "/tubes",
		currentClient: DEFAULT_CLIENT,
	},
	[API_DELETE_TUBE]: {
		default: "/tubes",
		v2: "/tubes",
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_REUSABLE_TUBE]: {
		default: (patientId) => `/tubes/reusable/${patientId}`,
		v2: (patientId) => `/tubes/reusable/${patientId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_MISSING_VOLUME_TUBE]: {
		default: (folderId) => `/tubes/volume/${folderId}`,
		v2: (folderId) => `/tubes/volume/${folderId}`,
		currentClient: DEFAULT_CLIENT,
	},
}

export function patchTube(tube) {
	const version = getVersion(API_PATCH_TUBE);
	const url = typeof version.path === 'function' ? version.path(tube) : version.path;
	return {
		type: API_PATCH_TUBE,
		payload: {
			request: {
				url,
				method: 'PATCH',
				data: tube,
			},
			client: version.currentClient,
		},
	};
}

export function patchMultipleTubes(tubes) {
	const version = getVersion(API_PATCH_MULTIPLE_TUBE);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_PATCH_MULTIPLE_TUBE,
		payload: {
			request: {
				url,
				method: 'PATCH',
				data: tubes,
			},
			client: version.currentClient,
		},
	};
}

export function addNotPrescribedTube(data) {
	const version = getVersion(API_POST_TUBE);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_POST_TUBE,
		payload: {
			request: {
				url,
				method: 'POST',
				data: data,
			},
			client: version.currentClient,
		},
	};
}

export function deleteNotPrescribedTube(data) {
	const version = getVersion(API_DELETE_TUBE);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_DELETE_TUBE,
		payload: {
			request: {
				url,
				method: 'DELETE',
				data: data,
			},
			client: version.currentClient,
		},
	};
}

export function getReusableTubes(patientId,data) {
	const version = getVersion(API_POST_REUSABLE_TUBE);
	const url = typeof version.path === 'function' ? version.path(patientId) : version.path;
	return {
		type: API_POST_REUSABLE_TUBE,
		payload: {
			request: {
				url,
				method: 'POST',
				data: data,
			},
			client: version.currentClient,
		},
	};
}

export function getMissingVolumeTubes(folderId) {
	const version = getVersion(API_GET_MISSING_VOLUME_TUBE);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_GET_MISSING_VOLUME_TUBE,
		payload: {
			request: {
				url,
				method: 'GET',
			},
			client: version.currentClient,
		},
	};
}
